<app-header
  [lang]="lang"
  [t]="t"
  (changeLang)="switchLang($event)"
></app-header>

<router-outlet></router-outlet>

<app-subfooter></app-subfooter>
<app-footer></app-footer>
